import { useRef, useEffect } from 'react';
import * as C from './constants';
import * as H from './helpers';
import IconSet from './line-awesome-icons.json';

// Export all common components from the aliased pre-built components package
export * from '@kineticdata/bundle-components-default';
export { C, H, IconSet };

// Export any custom components you defined to override the default ones
export { IconTypeahead } from './components/IconTypeahead';
export { Image } from './components/Image';
export { PaginationBar } from './components/PaginationBar';
export { PageTitle } from './components/PageTitle';
export { ReportSiteIssueWrapper } from './components/ReportSiteIssueWrapper';
export { cloneSubmission, createFile, postWebApi } from './api';

export function usePrevious(value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  const ref = useRef();
  // Store current value in ref
  useEffect(
    () => {
      ref.current = value;
    },
    [value],
  ); // Only re-run if value changes
  // Return previous value (happens before update in useEffect above)
  return ref.current;
}

export const getFileResourceURL = (slug, path) =>
  `/app/api/v1/fileResources/${slug}/files/${path}`;
